import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { FormErrors, ResetPasswordFormData } from '../types';

interface ResetPasswordFormProps {
  onSubmit: (data: ResetPasswordFormData) => Promise<void>;
  onBack: () => void;
  isLoading: boolean;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({ onSubmit, onBack, isLoading }) => {
  const [formData, setFormData] = useState<ResetPasswordFormData>({
    newPassword: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState<FormErrors>({});

  const validateForm = (): boolean => {
    const newErrors: FormErrors = {};

    if (!formData.newPassword.trim()) {
      newErrors.newPassword = 'Parola este obligatorie';
    } else if (formData.newPassword.length < 8) {
      newErrors.newPassword = 'Parola trebuie sa aiba minim 8 caractere';
    }

    if (!formData.confirmPassword.trim()) {
      newErrors.confirmPassword = 'Confirmarea parolei este obligatorie';
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Parolele nu coincid';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      await onSubmit(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="text-center mb-6">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-3">
          <Icon name="KeyRound" size={24} className="text-primary" />
        </div>
        <h2 className="text-2xl font-semibold text-foreground mb-2">Seteaza parola noua</h2>
        <p className="text-sm text-muted-foreground">
          Alege o parola noua pentru contul tau.
        </p>
      </div>

      <Input
        type="password"
        label="Parola noua"
        placeholder="Introdu parola noua"
        value={formData.newPassword}
        onChange={(e) => setFormData((p) => ({ ...p, newPassword: e.target.value }))}
        error={errors.newPassword}
        required
        disabled={isLoading}
        className="w-full"
      />

      <Input
        type="password"
        label="Confirma parola noua"
        placeholder="Confirma parola noua"
        value={formData.confirmPassword}
        onChange={(e) => setFormData((p) => ({ ...p, confirmPassword: e.target.value }))}
        error={errors.confirmPassword}
        required
        disabled={isLoading}
        className="w-full"
      />

      <div className="space-y-3">
        <Button type="submit" variant="default" size="lg" fullWidth loading={isLoading} iconName="Check" iconPosition="right">
          Reseteaza parola
        </Button>

        <Button
          type="button"
          variant="ghost"
          size="lg"
          fullWidth
          onClick={onBack}
          disabled={isLoading}
          iconName="ArrowLeft"
          iconPosition="left"
        >
          Inapoi la autentificare
        </Button>
      </div>
    </form>
  );
};

export default ResetPasswordForm;
